import React,{useState,useEffect} from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";

import { Button,FormGroup,Input } from "reactstrap";
import Loading from "../loader/loader";
const RoleSelect = (props) => {
  
  const[roleinfo,setRoleinfo]=useState("");
  const handleRole = (e) => {
    setRoleinfo(e.target.value);
    };
    useEffect(() => {
      if(props.row && props.row.role && props.row.role.id){
     setRoleinfo(props.row.role.id) 
      }
    
    }, [props.row]);
   
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      animation={false}
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div style={{ marginBottom: 15 }}>
        <FormGroup>
        <Input
                      id="exampleFormControlSelect1"
                      type="select"
                      value={roleinfo}
                      onChange={handleRole}
                      name="role"
                    >
{props.role &&props.role.data && props.role.data.map((ro)=>
                      <option value={ro.id}>{ro.name}</option>
)}
                    </Input>
                    </FormGroup>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>
          Cancel
        </Button>
        <Button variant="primary" disabled={props.loader} color="primary" onClick={()=>props.roleReassign(roleinfo)}>
                  {props.loader? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Save"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default RoleSelect;
